@import '@styles/colors.scss';

.strip {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 20px 0 0;
    font-family: var(--font-mono);
    font-size: 10px;
    color: var(--text-dim);
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.step {
    padding: 0 12px;
    border-left: 1px solid var(--border);
    line-height: 1.4;

    &:first-child {
        padding-left: 0;
        border-left: none;
    }
}

.stepNum {
    color: var(--text-muted);
    font-weight: 400;
}
